var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['common-stepper',_vm.disabled ? '__disabled': '']},[_c('van-stepper',{attrs:{"integer":"","min":_vm.min,"max":_vm.max,"disabled":_vm.disabled},on:{"change":_vm.change,"overlimit":_vm.overlimit},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }